import cloneDeep from 'lodash/cloneDeep'
import React, { useState } from 'react'
import { LuCheck } from 'react-icons/lu'

import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { DEFAULT_BULK_IMPORT_CIRCUMSTANCES } from '@/lib/constants'
import { ReferralsImportItem } from '@/redux/slices/referralsImportBase'

interface Props {
  importItem: ReferralsImportItem
  updateImportItem: (item: ReferralsImportItem) => void
}

const CircumstancesCell: React.FC<Props> = ({
  importItem,
  updateImportItem,
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const formRef = React.createRef<HTMLFormElement>()

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const newImportItem = cloneDeep(importItem)
    newImportItem.circumstances = event.currentTarget.circumstances.value
    updateImportItem(newImportItem)
    setIsEditing(false)
  }
  function handleInputChange() {
    formRef.current?.requestSubmit()
  }

  if (isEditing) {
    return (
      <>
        <form ref={formRef} onSubmit={handleOnSubmit}>
          <Textarea
            placeholder="Circumstances"
            defaultValue={importItem.circumstances}
            name="circumstances"
            rows={5}
            onBlur={handleInputChange}
          />
          <span className="mt-1 block text-right">
            <Button type="submit" size="icon-xs" variant="outline-primary">
              <LuCheck />
            </Button>
          </span>
        </form>
      </>
    )
  }

  return (
    <>
      <span className="cursor-pointer" onClick={() => setIsEditing(true)}>
        {importItem.circumstances ?? DEFAULT_BULK_IMPORT_CIRCUMSTANCES}
      </span>

      <span className="show-on-row-hover">
        {importItem.circumstances ? ', ' : ' '}
        <span className="text-xs">
          <Button variant="plain" onClick={() => setIsEditing(true)}>
            edit
          </Button>
        </span>
      </span>
    </>
  )
}

export default CircumstancesCell
